module.exports = __webpack_public_path__ + "static/media/top_prod_1.da3d3539.png";